import React from 'react';
import { ScrollView, Text, StyleSheet, View, Platform, TouchableOpacity } from 'react-native';
import CS from '../constants/Styles';
import Colors from '../constants/Colors';
import { Button, BackgroundGradient, Loader } from '../components';
import * as rtApi from '../components/Api';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { FontAwesome5 } from '@expo/vector-icons';
import { useLinkTo } from '@react-navigation/native';
import Terms from './SignUp/Terms';
import SignatureScreen from 'react-native-signature-canvas';
import { AntDesign } from '@expo/vector-icons';
import UserState from '../src/contexts/UserState';
import * as Location from 'expo-location';
import * as Application from 'expo-application';
import { getImageFieldsForUpload, dataUrlToFile } from '../utils/Functions';
import Storage from '../components/Storage';

const AcceptTermsScreen = ({ navigation, route, ...props }) => {
  const [user, setUser] = React.useContext(UserState);
  const [loading, setLoading] = React.useState(false);
  const [scrollEnabled, setScrollEnabled] = React.useState(true);
  
  const [signature, setSignature] = React.useState(null);
  // const [signatureFile, setSignatureFile] = React.useState(null);
  const [signatureText, setSignatureText] = React.useState('');
  const [uniqueDevice, setUniqueDevice] = React.useState(null);
  const [longitude, setLongitude] = React.useState(null);
  const [latitude, setLatitude] = React.useState(null);
  const isMounted = React.useRef(false);

  const insets = useSafeAreaInsets();
  const linkTo = useLinkTo();

  React.useEffect(() => {
    isMounted.current = true;
    getUniqueDevice();
    getLocation();
    return () => {
      rtApi.cancel();
      isMounted.current = false;
    }
  }, []);

  const getUniqueDevice = async () => {
    if (Platform.OS === 'ios') {
      setUniqueDevice(await Application.getIosIdForVendorAsync());
    } else if (Platform.OS === 'android') {
      setUniqueDevice(Application.androidId);
    }
  }
  const getLocation = async () => {
    let perm = await Location.getForegroundPermissionsAsync();
    console.log('getLocation', perm);
    if (perm.granted) {
      let loc = await Location.getCurrentPositionAsync({ accuracy: Location.Accuracy.High });
      if (isMounted.current) {
        setLongitude(loc.coords.longitude);
        setLatitude(loc.coords.latitude);
      }
    }
  }

  // const confirmTerms = () => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     setLoading(false);
  //     const u = {
  //       ...user,
  //       isLoggedIn: true,
  //       accepted_terms: 'Yes',
  //     };
  //     setUser(u);
  //     console.log('confirmTerms user: ', u);
  //     Storage.setItem('user', JSON.stringify(u));
  //   }, 2000);
  // }
  const confirmTerms = () => {
    if(signature || signatureText){
      const fd = buildFormData();
      setLoading(true);
      rtApi.put('terms', fd)
      .then(data => {
        if(data.result){
          const u = {
            ...user,
            isLoggedIn: true,
            accepted_terms: 'Yes',
          };
          setUser(u);
          Storage.setItem('user', JSON.stringify(u));
          if(route.params.signUp === 'yes'){
            linkTo('/projects/create_project_tutorial');
          }
        }
      }).catch(err => {
        console.log('confirmTerms catch: ', err);
      }).finally(() => {
        setLoading(false);
      });
    }
  }

  const buildFormData = () => {
    let fd = new FormData();
    // fd.append('accept_terms', 'yes');
    if(longitude){
      fd.append('longitude', longitude);
    }
    if(latitude){
      fd.append('latitude', latitude);
    }
    if(uniqueDevice){
      fd.append('unique_device', uniqueDevice);
    }
    if (Platform.OS !== 'web' && signature) {
      console.log('signature: ', signature);
      let imgDetails = getImageFieldsForUpload(signature.uri);
      fd.append('signature', {
        uri: signature.uri,
        name: imgDetails.filename,
        type: imgDetails.type,
      });
    }
    if (Platform.OS === 'web' && signatureText) {
      fd.append('signature_name', signatureText);
    }
    return fd;
  }

  return (
    <View style={[CS.container, { paddingTop: insets.top, paddingBottom: insets.bottom }]}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <ScrollView style={styles.terms} contentContainerStyle={styles.innerContainer} scrollEnabled={scrollEnabled}>
        {/* <TouchableOpacity onPress={goBack} style={{ marginTop: 10, marginBottom: 20, justifyContent: 'center' }}>
          <FontAwesome5 name="arrow-left" size={24} color="white" style={{ position: 'absolute' }} />
          <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, { marginVertical: 0 }]}>Terms of Use</Text>
        </TouchableOpacity> */}
        <Text style={[CS.mediumTitle, CS.lightText, CS.centerText]}>Terms of Use</Text>
        <Terms
          signatureText={signatureText}
          setSignatureText={setSignatureText}
          signature={signature}
          setSignature={setSignature}
          confirmTerms={confirmTerms}
          setScrollEnabled={setScrollEnabled}
        />
        
      </ScrollView>
    </View>
  )
}

const styles = StyleSheet.create({
  innerContainer: {
    width: '100%',
    // backgroundColor: 'pink',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    flexGrow: 1,
  },
  terms: {
    // marginTop: 20,
    marginVertical: 10,
    // backgroundColor: 'orange',
  },
});

export default AcceptTermsScreen;